import { type ReactNode } from "react";
import { useFeatureFlag } from "./useFeatureFlag";

type Props = {
  flag: string;
  children: ReactNode;
  fallback?: ReactNode;
};

/**
 * Conditionally renders children based on a feature flag.
 *
 * <FeatureGate flag="directory-v4-map">
 *   <NewMapView />
 * </FeatureGate>
 */
export const FeatureGate = ({ flag, children, fallback = null }: Props) => {
  const enabled = useFeatureFlag(flag);
  return <>{enabled ? children : fallback}</>;
};
